import { PropsWithChildren } from 'react';

import { useSetPageTitle } from '../../v2/app-shell/usePageTitle';

// The global app shell now provides the page chrome (sidebar + header). This
// layout only forwards the page title to the shell header. "Hub" is the generic
// default and is treated as no title.
const HeaderAndFooter = ({ children, title = 'Hub' }: PropsWithChildren<{ title?: string }>) => {
  useSetPageTitle(title === 'Hub' ? '' : title);
  return <>{children}</>;
};

export default HeaderAndFooter;
